import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';
import { ApryseSDK } from '../pdf/ApryseSDK';

export interface ISelectedStateState {
    stateName: string;
}

const initialState: ISelectedStateState = {
    stateName: ApryseSDK.ToolsENUM.PAN,
};

const reducers = {
    changeStateName: (state: ISelectedStateState, action: PayloadAction<string>) => {
        state.stateName = action.payload;
    },
};

export const selectedStateSlice = createSlice({
    name: 'selectedState',
    initialState,
    reducers,
});

export const selectedStateName = (state: IGlobalStoreReducers) => state.selectedState.stateName;

export const { changeStateName } = selectedStateSlice.actions;

export default selectedStateSlice.reducer;
